module.exports = __webpack_public_path__ + "static/media/info_12.e05b50c5.svg";